import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";

/** Sección colapsable para formularios largos (usable en móvil). */
export function Seccion({
  titulo,
  abierta,
  onToggle,
  children,
}: {
  titulo: string;
  abierta: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <section className="overflow-hidden rounded-lg border border-navy/15">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={abierta}
        className="grid w-full grid-cols-[minmax(0,1fr)_auto] items-center gap-3 bg-navy-soft px-4 py-3 text-left"
      >
        <span className="truncate text-sm font-semibold uppercase tracking-wide text-navy">
          {titulo}
        </span>
        <ChevronDown
          className={`h-4 w-4 shrink-0 text-navy transition-transform ${abierta ? "rotate-180" : ""}`}
        />
      </button>
      {abierta && <div className="px-4 py-4">{children}</div>}
    </section>
  );
}

/** Estado de apertura de secciones: por default solo la primera abierta. */
export function useSecciones<T extends string>(ids: readonly T[]) {
  const [abiertas, setAbiertas] = useState<Record<string, boolean>>(
    Object.fromEntries(ids.map((id, i) => [id, i === 0])),
  );
  return {
    abierta: (id: T) => !!abiertas[id],
    toggle: (id: T) => setAbiertas((s) => ({ ...s, [id]: !s[id] })),
  };
}
